import type SuperJSON from "superjson";

export async function getSuperjson(): Promise<typeof SuperJSON> {
  const mod = await import("superjson");
  return mod.default;
}
